// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"2528dd8c","154":"46537e31","159":"c2176b47","206":"1d1cc648","292":"eee7b6e0","412":"91cbdadb","696":"6940988f","761":"3ca473cb","787":"4f57ac2b","804":"3faa44e5","917":"7528d681","956":"867eec45"}[chunkId] + ".chunk.js";
};